// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Houses_main-container__OR_wz","non-bookable":"Houses_non-bookable__qYtA1"};